import { get, post } from "./data";

export const getTasksByContextKey = (key) => {
    return get(`/tasking/tasks/list/${key}`);
};

export const getTask = (taskId, isDuplicateStage) => {
    if (isDuplicateStage) {
        return get(`/duplicate-match/staging-task/${taskId}`);
    }

    return get(`/tasking/tasks/${taskId}`);
};

export const completeTasks = (payload, source, action, hideErrors) => {
    const sourcePage = source ? `sourcePage=${source}` : "";
    const actionState = action ? `&action=${action}` : "";

    return post(`/tasking/tasks/statechanges/multiple?${sourcePage}${actionState}`, payload, {
        displayError: !hideErrors,
        passthrough: true,
    });
};

export const changeTaskState = (taskId, payload, skipTaskCompleteUpdates = false, sourcePage, action) => {
    // Allows:
    // {
    //    state: 'string',
    //    data: 'string'
    //    changedOn: '2018-03-20T22:24:33.962Z',
    //    changedBy: 'string'
    // }
    payload = {
        ...payload,
    };
    const source = sourcePage ? `&sourcePage=${sourcePage}` : "";
    const actionState = action ? `&action=${action}` : "";

    return post(`/tasking/tasks/${taskId}/statechanges?skipNextStepsOnCompletion=${skipTaskCompleteUpdates}${source}${actionState}`, payload);
};

export const completeTask = (taskId, skipTaskCompleteUpdates, overridePayload, sourcePage, action = "complete") => {
    const payload = overridePayload || {
        state: "completed",
    };

    return changeTaskState(taskId, payload, skipTaskCompleteUpdates, sourcePage, action);
};

export const rejectTask = (taskId, overridePayload, sourcePage, action = "reject") => {
    const payload = overridePayload || {
        state: "completed",
        data: "rejected",
    };

    return changeTaskState(taskId, payload, false, sourcePage, action);
};

export const validateTask = (key, override, settings = {}, isReject) => {
    const overrideParam = override ? (isReject ? "&hasUserConfirmedOverridableErrors=true" : "?hasUserConfirmedOverridableErrors=true") : "";
    const checkRejection = isReject ? "?isRejection=true" : "";
    const url = `/tasking/tasks/${key}/validate${checkRejection}${overrideParam}`;

    return post(url, {}, settings);
};

export const validateTaskReject = (key, payload, override, settings = {}) => {
    const overrideParam = override ? "?hasUserConfirmedOverridableErrors=true" : "";
    const url = `/tasking/tasks/${key}/rejection-check${overrideParam}`;

    return post(url, payload, settings);
};

export const editTask = (taskId, skipTaskCompleteUpdates, overridePayload, sourcePage, action = "") => {
    const payload = overridePayload || {
        state: "ready",
    };

    return changeTaskState(taskId, payload, skipTaskCompleteUpdates, sourcePage, action);
};
